import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_HOME } from "../lib/format";

export function PageLoader({ label = "Memuat..." }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f7f9fc]" data-testid="page-loader">
      <div className="flex flex-col items-center gap-3">
        <span className="w-10 h-10 rounded-full border-4 border-blue-100 border-t-blue-600 animate-spin" />
        <p className="text-sm font-semibold text-slate-500">{label}</p>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <PageLoader label="Memeriksa sesi..." />;
  if (!user) return <Navigate to="/masuk" replace state={{ from: location.pathname }} />;
  if (!user.role) return <Navigate to="/pilih-peran" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role] || "/"} replace />;
  return <Outlet />;
}
